var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V96H496V16Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 96H16V176H496V96Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 176H16V256H496V176Z",
    fill: "#E74C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V336H496V256Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 336H16V416H496V336Z",
    fill: "#F1C40F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M496 416H16V496H496V416Z",
    fill: "#E74C3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M256 332C297.974 332 332 297.974 332 256C332 214.026 297.974 180 256 180C214.026 180 180 214.026 180 256C180 297.974 214.026 332 256 332Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.605 197.792L237.675 188.712C239.577 186.81 242.778 185.34 247.879 185.34C247.879 185.686 247.36 195.284 247.36 195.284L242.605 197.792Z",
    fill: "#D90000",
    stroke: "black",
    strokeWidth: 1.00132
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M247.36 195.371L248.052 185.34C248.052 185.34 258.256 184.736 263.79 191.394C263.877 191.307 258.343 199.176 258.343 199.176L247.36 195.371Z",
    fill: "#FCDC04",
    stroke: "black",
    strokeWidth: 1.00132
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M258.516 199.089L263.531 191.307C266.903 194.852 268.286 197.36 268.805 201.165C268.892 201.251 260.85 203.153 260.85 203.067C260.85 202.98 258.602 199.175 258.516 199.089V199.089Z",
    fill: "#D90000",
    stroke: "black",
    strokeWidth: 1.00132
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M245.112 327.587C245.112 327.587 254.538 316.778 272.87 319.113C270.103 314.616 261.196 315.135 261.196 315.135C261.196 315.135 258.429 294.123 260.591 293.085C262.753 292.047 271.919 293.171 271.919 293.171C273.129 293.171 275.205 289.885 273.562 287.81C271.919 285.734 267.076 277.779 269.065 276.222C271.054 274.666 281.863 277.087 281.863 277.087L251.338 238.002C251.338 238.002 248.225 223.301 254.451 216.211C261.975 209.984 261.196 203.24 260.937 203.326C259.899 196.495 249.523 191.565 242.518 197.878C238.367 202.894 241.134 206.698 241.134 206.698C241.134 206.698 230.239 209.639 229.807 211.541C229.374 213.443 242.086 211.195 242.086 211.195L240.875 219.929C240.875 219.929 216.144 242.411 235.081 261.868C235.254 261.781 235.687 261.003 235.687 261.003C235.687 261.003 242.345 269.218 249.349 271.034C255.921 277.779 255.316 276.741 255.316 276.741C255.316 276.741 256.613 287.378 255.403 289.453C253.76 288.934 236.984 288.329 234.476 289.28C232.228 289.972 223.581 289.539 225.742 303.635C227.385 299.83 228.855 296.457 228.855 296.457C228.855 296.457 228.596 301.559 230.672 303.375C230.326 298.013 232.66 294.382 232.66 294.382C232.66 294.382 233.093 300.262 234.389 301.126C235.687 301.991 235.687 291.614 242.864 292.479C250.041 293.344 255.23 293.085 255.23 293.085C255.23 293.085 257.651 313.405 256.873 315.308C251.684 314.097 239.319 315.827 238.54 318.94C245.804 318.508 249.177 319.372 249.177 319.372C249.177 319.372 243.297 324.561 245.112 327.587V327.587Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.00132
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M248.027 216.707C248.027 216.707 230.032 236.542 237.796 251.72C238.209 249.603 238.029 248.274 238.288 248.36C237.856 248.101 240.52 250.186 240.317 249.78C240.374 248.683 239.506 246.331 239.506 246.331C240.317 246.534 241.129 246.737 241.941 246.94C241.467 246.061 240.993 245.182 240.52 244.302C241.67 244.438 242.819 244.572 243.97 244.708C243.97 244.708 242.752 241.461 243.158 241.461C243.564 241.461 245.999 241.664 245.999 241.664C240.881 232.48 245.709 224.853 248.027 216.707Z",
    fill: "#9CA69C",
    stroke: "#9CA69C",
    strokeWidth: 1.00132
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.279 199.695C254.279 199.695 255.23 206.527 251.512 208.515C250.906 208.948 248.572 209.726 248.918 211.11C249.35 213.012 250.387 212.666 251.858 212.32C255.748 211.628 260.245 203.327 254.279 199.695V199.695Z",
    fill: "#9CA69C",
    stroke: "#9CA69C",
    strokeWidth: 1.00132
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M246.246 207.067C247.054 207.067 247.709 206.412 247.709 205.604C247.709 204.796 247.054 204.141 246.246 204.141C245.438 204.141 244.783 204.796 244.783 205.604C244.783 206.412 245.438 207.067 246.246 207.067Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M241.827 211.281C240.875 212.06 235.86 217.248 240.789 219.151C245.891 217.767 244.507 216.816 245.631 215.692C245.66 213.357 243.095 212.752 241.827 211.281Z",
    fill: "#D90000",
    stroke: "black",
    strokeWidth: 1.00132
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M252.722 260.312C252.462 261.437 251.338 265.587 252.895 268.787C257.218 266.971 259.207 267.489 260.677 268.441C257.133 265.587 255.749 264.376 252.722 260.312Z",
    fill: "#9CA69C",
    stroke: "#9CA69C",
    strokeWidth: 1.00132
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M260.159 279.941L260.418 289.626C260.418 289.626 263.791 290.232 265.347 289.626C266.904 289.021 265.26 282.881 260.159 279.941Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.00132
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M284.63 281.152C284.63 281.152 278.404 266.106 262.493 262.301C246.582 258.496 248.657 241.548 249.954 240.51C250.646 239.04 251.165 236.792 255.748 238.954C260.331 241.116 281.431 251.751 284.457 252.27C287.484 252.789 284.89 281.498 284.63 281.152V281.152Z",
    fill: "#9CA69C",
    stroke: "black",
    strokeWidth: 1.00132
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M269.497 262.215C269.238 262.388 290.77 274.926 284.284 285.735C290.424 281.671 288.435 274.581 288.435 274.581C288.435 274.581 293.45 287.638 281.258 294.037C282.555 295.162 283.42 294.901 283.42 294.901L281.344 296.977C281.344 296.977 280.393 298.533 288.608 294.556C286.359 296.372 286.187 297.669 286.187 297.669C286.187 297.669 286.792 299.398 292.153 294.729C287.83 299.398 286.878 301.819 286.878 301.733C298.552 300.695 323.975 262.734 278.837 251.492C281.258 254 280.912 253.654 280.912 253.654L269.497 262.215Z",
    fill: "#D90000",
    stroke: "black",
    strokeWidth: 1.00132
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M270.449 258.496C273.389 260.571 274.426 261.263 274.772 262.301C272.092 261.696 269.671 261.868 269.671 261.868C269.671 261.868 263.877 256.334 262.839 255.902C262.061 255.902 257.565 253.048 257.565 253.048C255.317 251.924 253.241 244.142 261.543 246.39C270.103 250.454 271.313 250.8 271.313 250.8C274.715 251.866 278.116 252.933 281.517 254C283.478 256.19 285.437 258.381 287.397 260.572C287.397 260.572 276.935 255.383 275.637 255.296C278.491 257.631 280.134 260.831 280.134 260.831C276.819 259.879 273.937 259.015 270.449 258.496V258.496Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.00132
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M229.72 212.06C229.72 212.06 239.751 209.639 240.961 209.985Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M229.72 212.06C229.72 212.06 239.751 209.639 240.961 209.985",
    stroke: "white",
    strokeWidth: 1.00132
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/UG.3f31a58e14cddebbb127f9e0cd78cccf.svg";
export { ForwardRef as ReactComponent };